import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { sendEmailVerifyCode, verifyConfirmationCode } from './profileAPI';
import {
  setEditingRegistrationEmail,
  setEmailErrors,
  setVerifyCodeSent,
  setVerifyCodeSuccessful,
} from './profileReducer';
import { getCustomerParty } from './selectors';
import {
  CancelButton,
  EditEmailContainer,
  RegistrationEmailAddressInputContainer,
  RegistrationEmailAddressInput,
  SaveEmailButton,
} from './styles';
import { isEmail } from '../../../utils/validators/generalValidators';
import { useSnackbar } from 'notistack';
import { Dialog } from '@mui/material';
import { ModalContainer, ModalHeader } from '../enable-mfa/styles';
import { ConfirmVerificationCode, EmailVerificationCodeInput } from '../create-account/styles';
import Loader from '../../common/loader';

const EditingRegistrationEmail = (props) => {
  const {
    dispatch,
    customerId,
    userEmail,
    user,
    isVerifyCodeSent,
    isVerifyCodeSuccessful,
    isEmailLoading,
  } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [email, setEmail] = React.useState(userEmail ? userEmail : '');
  const [openModal, setOpenModal] = React.useState(false);
  const [sendingCode, setSendingCode] = React.useState(false);
  const [emailVerificationCode, setEmailVerificationCode] = React.useState('');

  const handleModalClose = () => {
    setOpenModal(false);
    dispatch(setVerifyCodeSent(false));
  };

  useEffect(() => {
    if (isVerifyCodeSent) {
      setSendingCode(false);
      setOpenModal(true);
    } else {
      setOpenModal(false);
      props.dispatch(setVerifyCodeSuccessful(false));
    }
  }, [isVerifyCodeSent]);

  useEffect(() => {
    if (isVerifyCodeSuccessful) {
      //Resetting
      setOpenModal(false);
      props.dispatch(setVerifyCodeSuccessful(false));
      props.dispatch(setVerifyCodeSent(false));
    }
  }, [isVerifyCodeSuccessful]);

  const sendVerificationCode = () => {
    setSendingCode(true);
    props.dispatch(sendEmailVerifyCode(user.preferred_username, customerId, enqueueSnackbar));
  };

  const cancelEmail = () => {
    dispatch(setEditingRegistrationEmail(false));
    dispatch(setEmailErrors(null));
  };

  const submitVerificationCode = () => {
    dispatch(
      verifyConfirmationCode(
        user.preferred_username,
        emailVerificationCode,
        customerId,
        { email: email },
        user,
        setEmailVerificationCode,
        enqueueSnackbar,
      ),
    );
  };

  const isValidEmail = () => {
    return email !== '' && isEmail(email);
  };

  const isValidCode = (currentCode) => {
    return currentCode.length !== 0 && currentCode.trim().length !== 0;
  };

  return (
    <>
      {isEmailLoading ? (
        <Loader />
      ) : (
        <>
          <EditEmailContainer>
            <RegistrationEmailAddressInputContainer>
              <RegistrationEmailAddressInput
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                aria-label="Email Address"
              />
            </RegistrationEmailAddressInputContainer>
          </EditEmailContainer>
          {sendingCode ? (
            <Loader />
          ) : (
            <SaveEmailButton disabled={!isValidEmail()} onClick={() => sendVerificationCode()}>
              Apply
            </SaveEmailButton>
          )}
          <CancelButton
            onClick={() => {
              cancelEmail();
            }}
          >
            Cancel
          </CancelButton>
          <Dialog open={openModal} onClose={handleModalClose}>
            <ModalContainer>
              <>
                <ModalHeader>Confirm Email Address</ModalHeader>
                <div>Please enter your email verification code.</div>
                <EmailVerificationCodeInput
                  type="text"
                  onChange={(e) => setEmailVerificationCode(e.target.value)}
                />
                {isVerifyCodeSent ? (
                  <ConfirmVerificationCode
                    disabled={!isValidCode(emailVerificationCode)}
                    onClick={() => submitVerificationCode(emailVerificationCode)}
                  >
                    Submit
                  </ConfirmVerificationCode>
                ) : (
                  <Loader />
                )}
              </>
            </ModalContainer>
          </Dialog>
        </>
      )}
    </>
  );
};

EditingRegistrationEmail.propTypes = {
  customerSubscriptionsFull: PropTypes.any,
  dispatch: PropTypes.func,
  isLoading: PropTypes.bool,
  isEmailLoading: PropTypes.bool,
  mfaOptions: PropTypes.array,
  isVerifyCodeSuccessful: PropTypes.bool,
  isVerifyCodeSent: PropTypes.bool,
  customerParty: PropTypes.object,
  customer: PropTypes.object,
  customerId: PropTypes.string,
  userEmail: PropTypes.string,
  cancelEmail: PropTypes.func,
  user: PropTypes.object,
  verifyFlow: PropTypes.bool,
};
const mapStateToProps = (state) => ({
  isLoading: state.profileSlice.isLoading,
  isEmailLoading: state.profileSlice.isEmailLoading,
  isVerifyCodeSuccessful: state.profileSlice.isVerifyCodeSuccessful,
  isVerifyCodeSent: state.profileSlice.isVerifyCodeSent,
  mfaOptions: state.mfaSlice.mfaOptions,
  emailErrors: state.profileSlice.emailErrors,
  editingEmail: state.profileSlice.editingEmail,
  customerId: state.loginSlice.user.preferred_username,
  userEmail: state.loginSlice.user.email,
  user: state.loginSlice.user,
  systemId: state.customerSlice.customer.systemId,
  customer: state.customerSlice.customer,
  customerSubscriptionsFull: state.notificationSlice.customerSubscriptionsFull,
  customerParty: getCustomerParty(state),
  verifyFlow: state.configurationSlice.features.features.verifyFlow,
});

export default connect(mapStateToProps)(EditingRegistrationEmail);
